import { get, put, post } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async list(requestModel) {
    if (!requestModel?.privilege) {
      throw new Error("Privilege is required");
    }

    return await post("user/customers", requestModel);
  },

  async get({ customerid } = {}) {
    if (!customerid) {
      throw new Error("Customer ID is required");
    }

    return await get(`customer/${encodeURIComponent(customerid)}`);
  },

  async getAdminCustomerList() {
    return await get("customer/list");
  },

  async getCustomerLogos() {
    return await get("customer/logos");
  },

  async getCustomerLogo(customerId) {
    return await get(`customer/${encodeURIComponent(customerId)}/logo`);
  },

  async getListOfFacilities(id) {
    return await get(`customer/${encodeURIComponent(id)}/facilities`);
  },

  async getActiveLocationHierarchies(id) {
    return await get(`customer/${encodeURIComponent(id)}/locationHierarchies`);
  },

  async postCustomerLogo(customerId, file) {
    const data = new FormData();
    data.append("logo", file);

    return await post(`customer/${encodeURIComponent(customerId)}/logo`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  async saveCustomer(customer) {
    if (customer.id) {
      return await put(`customer/${encodeURIComponent(customer.id)}`, customer);
    } else {
      return await post(`customer`, customer);
    }
  },

  async setCustomerActiveStatus(id, status) {
    return await put(
      uriWithQueryStringParams(
        `customer/${encodeURIComponent(id)}/ActiveStatus/`,
        { status }
      )
    );
  }
};
